import React, { useState } from "react";
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, Input } from "reactstrap";

const Search = ({ onSearch }) => {
  const [query, setQuery] = useState("");

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  const handleSearch = () => {
    if (onSearch) {
      onSearch(query);
    }
  };
  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);

  return (
    <div className="search-component">
      <Button
        size="sm"
        color="light"
        className="shadow-none d-flex justify-content-center align-items-center"
        onClick={toggleModal}
      >
        <i className="bx bx-search fs-18"></i>
      </Button>

      <Modal
        size="lg"
        isOpen={modal}
        toggle={toggleModal}
        className="border-4 overflow-hidden position-relative"
        backdrop={true}
      >
        {/* <ModalHeader
                className="bg-transparent p-2 m-0 position-absolute top-0 end-0 z-1"
                toggle={toggleModal}
            ></ModalHeader> */}
        <ModalBody>
          <div className="d-flex justify-content-center align-items-center">
            <span className="bg-light px-2 py-1 rounded-3">Search</span>
            <Input
              type="text"
              value={query}
              onChange={handleInputChange}
              placeholder="Type to search for entries"
              className="border-0 shadow-0"
            />
            <Button
              color="transparent"
              onClick={handleSearch}
              className="shadow-none"
            >
              <i className="bx bx-search fs-18"></i>
            </Button>
          </div>
          <div className="border-top mt-3">
            <ul className="list-unstyled">
              <li className="fs-14 pt-3">
                Search by typing three characters or more.{" "}
                <span className="text-muted">33/44</span>
              </li>
              <li className="fs-14 pt-3">
                Search by typing three characters or more.{" "}
                <span className="text-muted">33/44</span>
              </li>
              <li className="fs-14 pt-3">
                Search by typing three characters or more.{" "}
                <span className="text-muted">33/44</span>
              </li>
              <li className="fs-14 pt-3">
                Search by typing three characters or more.{" "}
                <span className="text-muted">33/44</span>
              </li>
            </ul>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Search;
